document.addEventListener('DOMContentLoaded', () => {
  const SPEED = 60; // pixels per second
  const scrollingModules = document.querySelectorAll<HTMLElement>('.js-scrolling-links');

  const setupModule = (module: HTMLElement, index: number) => {
    const tracks = module.querySelectorAll<HTMLElement>('.js-scrolling-links-track');
    const scroller = module.querySelector<HTMLElement>('.scrolling-links__scroller');

    if (!scroller || tracks.length < 2) {
      return;
    }

    const [trackA, trackB] = tracks;

    // Remove previous animation styles (important when resizing)
    trackA.style.animation = '';
    trackB.style.animation = '';

    // Remove any prior keyframes for this module
    const oldStyle = document.getElementById(`scrolling-style-${index}`);
    if (oldStyle) {
      oldStyle.remove();
    }

    // Measure track width AFTER layout/resize
    const width = trackA.scrollWidth;

    // Position the second track
    trackA.style.left = '0px';
    trackB.style.left = `${width}px`;

    // Duration for consistent speed
    const duration = width / SPEED;

    // Create new keyframes
    const animationName = `scrolling-marquee-${index}-${Date.now()}`;

    const style = document.createElement('style');
    style.id = `scrolling-style-${index}`;
    style.innerHTML = `
      @keyframes ${animationName} {
        from { transform: translateX(0); }
        to { transform: translateX(-${width}px); }
      }
    `;
    document.head.appendChild(style);

    // Apply animation
    [trackA, trackB].forEach((track) => {
      track.style.animation = `${animationName} ${duration}s linear infinite`;
    });
  };

  // Initial setup
  scrollingModules.forEach((module, index) => setupModule(module, index));

  // Recalculate on resize (with debounce)
  let resizeTimeout: number | undefined;

  let lastViewportWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    // iOS fires "fake" resize events when scrolling, so if width doesn't change ignore it
    if (window.innerWidth === lastViewportWidth) {
      return;
    };

    lastViewportWidth = window.innerWidth;

    window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      scrollingModules.forEach((module, index) => setupModule(module, index));
    }, 200);
  });
});
